import { render } from "./GroupInsuranceBenefits.vue?vue&type=template&id=b91690ca&scoped=true&ts=true"
import script from "./GroupInsuranceBenefits.vue?vue&type=script&lang=ts"
export * from "./GroupInsuranceBenefits.vue?vue&type=script&lang=ts"

import "./GroupInsuranceBenefits.vue?vue&type=style&index=0&id=b91690ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b91690ca"]])

export default __exports__